import React from 'react';
import { Search, Plus } from 'lucide-react';

const UserFilters = ({ filters, onFilterChange, onAddUser, userCount = 0, isStaffMode = false }) => {
    const tabs = isStaffMode
        ? [
            { id: 'all_staff', label: 'All Staff' },
            { id: 'academic', label: 'Academic Staff' },
            { id: 'non_academic', label: 'Non-Academic' }
        ]
        : [
            { id: 'all', label: 'All Users' },
            { id: 'student', label: 'Students' },
            { id: 'academic', label: 'Academic Staff' },
            { id: 'non_academic', label: 'Non-Academic' }
        ];

    return (
        <div className="flex flex-col lg:flex-row gap-3 justify-between items-center bg-card p-3 rounded-xl border shadow-sm">
            {/* Title & Count + Role Tabs */}
            <div className="flex flex-wrap items-center gap-4 w-full lg:w-auto">
                <div className="flex items-center gap-2">
                    <h1 className="text-xl font-bold tracking-tight text-foreground">
                        {isStaffMode ? 'Staff Directory' : 'Active Users'}
                    </h1>
                    <span className="px-2 py-0.5 text-xs font-semibold bg-muted text-muted-foreground rounded-full border">
                        {userCount}
                    </span>
                </div>

                {/* Role Tabs */}
                <div className="flex bg-muted p-1 rounded-lg">
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => onFilterChange({ ...filters, role: tab.id })}
                            className={`px-3 py-1.5 text-xs font-medium rounded-md transition-all ${
                                filters.role === tab.id
                                    ? 'bg-background text-foreground shadow-sm'
                                    : 'text-muted-foreground hover:text-foreground hover:bg-background/50'
                            }`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Search, Status & Action Button */}
            <div className="flex items-center gap-2 w-full lg:w-auto justify-end">
                <div className="relative flex-1 lg:w-56">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground" />
                    <input
                        type="text"
                        placeholder="Search users..."
                        value={filters.search}
                        onChange={(e) => onFilterChange({ ...filters, search: e.target.value })}
                        className="w-full pl-8 pr-3 py-1.5 text-xs border rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-background"
                    />
                </div>

                <select
                    value={filters.status}
                    onChange={(e) => onFilterChange({ ...filters, status: e.target.value })}
                    className="px-2.5 py-1.5 text-xs border rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-primary text-foreground"
                >
                    <option value="all">All Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                    <option value="deactivated">Deactivated</option>
                </select>

                <button
                    onClick={onAddUser}
                    className="flex items-center gap-1.5 px-3 py-1.5 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-all text-xs font-medium shadow-sm shrink-0"
                >
                    <Plus className="h-3.5 w-3.5" />
                    <span>Add New User</span>
                </button>
            </div>
        </div>
    );
};

export default UserFilters;
